import { UserCapabilityName } from 'types/userCapabilityName';
import { IRoutePermissions } from '../../types/common';

export const homeRoutePerm: IRoutePermissions = {
  userCapabilities: [
    UserCapabilityName.FeatureToggleViewer,
    UserCapabilityName.FeatureToggleAdmin,
  ],
};
export const featureTogglesRoutePerm: IRoutePermissions = {
  userCapabilities: [
    UserCapabilityName.FeatureToggleViewer,
    UserCapabilityName.FeatureToggleAdmin,
  ],
};
